import { render, staticRenderFns } from "./FormBuilderElementComponent.vue?vue&type=template&id=17a55156&scoped=true"
import script from "./FormBuilderElementComponent.vue?vue&type=script&lang=js"
export * from "./FormBuilderElementComponent.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderElementComponent.vue?vue&type=style&index=0&id=17a55156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a55156",
  null
  
)

export default component.exports